export default {
  apiKey: "AIzaSyCovv-7dvADLis4ibJ4v7C6LcUsVBIPQPI",
  authDomain: 'regularli-neo.firebaseapp.com',
  databaseURL: 'https://regularli-neo.firebaseio.com',
  projectId: 'regularli-neo',
  storageBucket: "regularli-neo.appspot.com",
  messagingSenderId: '138763677614',
  gcm_sender_id : '138763677614',
  appId: "1:138763677614:web:5c0b6460d31a8a7e2f623f",
  measurementId : "G-RL52SQ1914"

};
